<div *ngFor="let sess of meetings">
    {{ sess }}
</div>
